import React, { useState } from "react";
import Sidebar from "../../components/sidebar/sidebar";
import "./contractsTypes.css";
import Topbar from "../../components/topbar/topbar";
import Card from "react-bootstrap/Card";
import { columns } from "./columns.jsx";
import Content from "../../components/contractsTypes/addcontractstypes/indexAddContractType";
import MUIDataTable from "mui-datatables";
import Fontawesome from "../../components/fontawesome/fontawesome";
import { Prefix } from "../../services/prefix";
import { useFetch } from "../../components/hooks/useFetch";
import Loading from "../../components/loader/loading";
import api from "../../services/api";
import Swal from "sweetalert2";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomSearchRender from "../../components/customSearchRender/CustomSearchRender";
import CustomFooter from "../../components/CustomFooter/CustomFooter";
import {
  CardSt,
  CardHeaderSt,
  IconTitleSt,
  TitleSt,
  TextTitleSt,
  SmallTitleSt,
} from "../../style/globalStyle";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { GetMuiTheme } from "../../components/muiTheme/muiTheme";
import {mutate as GlobalMutate} from 'swr';

export const ContractsTypes = () => {
  const [loader, setLoader] = useState();
  const [pagina, setPagina] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [search, setSearch] = useState("");
  const [orderBy, setOrderBy] = useState("id");
  const [order, setOrder] = useState("desc");

  let pageExact = pagina + parseInt(1);

  const contracttypeList = useFetch(
    Prefix.replace(/[\\"]/g, "") +
      "/contract-types?per_page=" +
      perPage +
      "&page=" +
      pageExact +
      "&search=" +
      search +
      "&order_by=" +
      orderBy +
      "&order=" +
      order
  );

  const options = {
    filterType: "dropdown",
    draggableColumns: {
      enabled: true,
    },
    sortOrder:{ 
      name: orderBy, 
      direction: order, 
    },
    filter: false,
    serverSide: true,
    onTableChange: (action, tableState) => {
      setOrderBy(
        !tableState.sortOrder.name ? orderBy : tableState.sortOrder.name,
      );
      setOrder(
        !tableState.sortOrder.direction
          ? order
          : tableState.sortOrder.direction,
      );
      setPagina(tableState.page);
      setPerPage(tableState.rowsPerPage);
    },
    onSearchChange: (searchText) => {
      setSearch(!searchText ? "" : searchText);
    },
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <CustomSearchRender
          placeholderSearch="Pesquisar cliente"
          searchText={searchText}
          onSearch={handleSearch}
          onHide={hideSearch}
          options={options}
        />
      );
    },
    filter: false,
    page: pagina,
    count: contracttypeList.data?.models?.total,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    rowsPerPage: perPage,
    rowsPerPageOptions: [15, 30, 100],
    isRowExpandable: (dataIndex, expandedRows) => {
      if (dataIndex === 3 || dataIndex === 4) return false;
      if (
        expandedRows.data.length > 4 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Row>
              <Col className="text-center">
                <strong>----</strong> {rowData[2]}
                <br />
                <strong>----</strong>{" "}
                {rowData[8] +
                  ", " +
                  rowData[10] +
                  ", " +
                  rowData[9] +
                  ", " +
                  rowData[7]}
                <br />
                <strong>------</strong> {rowData[12]}
              </Col>
            </Row>
          </TableCell>
        </TableRow>
      );
    },
    onRowsDelete: (rowsDeleted, newData) => {
      HandleDelete(rowsDeleted.data);
    },

    searchPlaceholder: "Pesquise um tipo de contrato",
    selectableRows: "multiple",
    searchOpen: true,

    textLabels: {
      body: {
        noMatch: "Desculpe, não encontramos tipos de contratos!",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Avançar",
        previous: "Voltar",
        rowsPerPage: "Linhas por página:",
        displayRows: "de",
      },

      toolbar: {
        search: "Pesquisar",
        downloadCsv: "Baixar CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar tabela",
      },
      filter: {
        all: "Tudo",
        title: "FILTROS",
        reset: "RESETAR",
      },
      viewColumns: {
        title: "Exibir colunas",
        titleAria: "Exibir/Ocultar colunas da tabela",
      },
      selectedRows: {
        text: "Coluna(s) selecionada(s)",
        delete: "Excluir",
        deleteAria: "Excluir linhas selecionadas",
      },
    },
    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels
    ) => {
      let numberPages = contracttypeList.data?.models?.last_page;
      let rowsPerPageOptions = [15, 30, 100];
      return (
        <CustomFooter
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          numberPages={numberPages}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      );
    },
  };

  function HandleDelete(e) {
    setLoader(<Loading />);
    let idArr = [];

    e.map((del) => {
      idArr.push(
        contracttypeList.data?.models?.data.filter(
          //Lista dados de cityList e filtra os que serão removidos
          (filtro, index) => index == del.index
        )[0].id
      );
    });

    idArr.map(
      (
        idDel //Faz exclusão com map um a um para evitar bugs
      ) =>
        api
          .delete(Prefix.replace(/[\\"]/g, "") + "/contract-types/" + idDel)
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Uow!",
              text: response.data.message,
              confirmButtonText: "Fechar",
            });
            setLoader();
            GlobalMutate(
              Prefix.replace(/[\\"]/g, "") +
              "/contract-types?per_page=" +
              perPage +
              "&page=" +
              pageExact +
              "&search=" +
              search +
              "&order_by=" +
              orderBy +
              "&order=" +
              order
          );
            contracttypeList.mutate();
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message,
              confirmButtonText: "Tentar novamente",
            });
            setLoader();
          })
    );
  }

  console.clear();

  return (
    <div className="wrapper d-flex align-items-stretch">
      <Sidebar />
      {loader}
      <div id="content">
        <Topbar />
        <div className="content_all">
          <CardSt>
            <CardHeaderSt className="d-flex justify-content-between">
              <TitleSt>
                <IconTitleSt
                  style={{ width: "28px" }}
                  src="../../../media/icons-pages/type-contract-page.svg"
                />
                <TextTitleSt>
                  Tipos de Contrato{" "}
                  <SmallTitleSt>Gestão de Tipos de Contrato</SmallTitleSt>
                </TextTitleSt>
              </TitleSt>
            </CardHeaderSt>
            <CardSt.Body as="div">
              <CardSt.Text as="div">
                <MuiThemeProvider theme={GetMuiTheme()}>
                  <MUIDataTable
                    data={contracttypeList.data?.models?.data}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </CardSt.Text>
            </CardSt.Body>
          </CardSt>
          <Content
            titleLabel="Cadastro de Tipos de Contrato"
            buttonLabel="Adicionar"
            iconClass="fas fa-plus-circle"
            modalSize="md"
            pageExact={pageExact}
            perPage={perPage}
            orderBy={orderBy}
            order={order}
          />
        </div>
      </div>
    </div>
  );
};

export default ContractsTypes;
